<template>
  <v-container grid-list-md text-xs-left v-if="restriction !== null && pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{restriction.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs8>
        <v-layout column>
          <v-flex>

              <v-layout row class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <v-avatar
                      :tile="false"
                      :size="72"
                      color="grey lighten-4"
                      class="ma-3 float-left"
                  >
                    <img :src="restriction.created_user.photo.url_resized" alt="avatar">
                  </v-avatar>
                  <div>
                    <p class="title mt-4">{{restriction.created_user.surname + ' ' + restriction.created_user.first_name + ' ' + restriction.created_user.patronymic}}</p>
                    <p class="body-2 mt-3">{{restriction.created_user.user_group.title}}</p>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <div>
                    <span class="title">Дата создания: </span>
                    <span class="title font-weight-thin">{{ $moment(restriction.created_datetime).format('D MMM YYYY, HH:mm') }}</span>
                  </div>
                </v-flex>
              </v-layout>

              <p class="title">Каналы продаж</p>
              <v-layout
                  row
                  v-if="channelList.length > 0"
                  class="elevation-1 white mb-4 px-3 pt-3 pb-0"
              >
                <v-flex xs12 lg6 md6>
                  <div
                      v-for="(channel, index) in channelList"
                      :key="channel.id"
                  >
                    <v-checkbox
                        disabled
                        :label="channel.title"
                        v-model="channelList[index].checked"
                        class="ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>

              <p class="title">Торговые точки</p>
              <v-layout row v-if="pointListTreeData !== null && pointListTreeData.length > 0" class="elevation-1 white mb-4 pa-3">
                <v-flex xs12 lg6 md6>
                  <tree
                      :options="{
                        checkbox: true
                      }"
                      :data="pointListTreeData"
                      class="tree--small tree-single-page"
                  />
                </v-flex>
              </v-layout>

              <p class="title">Товары</p>
              <v-layout row v-if="productListTreeData !== null && productListTreeData.length > 0" class="elevation-1 white mb-4 pa-3">
                <v-flex xs12 lg6 md6>
                  <tree
                      :options="{
                        checkbox: true
                      }"
                      :data="productListTreeData"
                      class="tree--small tree-single-page"
                  />
                </v-flex>
              </v-layout>

              <v-layout row class="pa-0 mt-3 mb-3">
                <v-flex xs12 lg12 md12>
                  <div class="float-left inline-block">
                    <p class="title">Дата начала</p>
                    <v-date-picker
                        class="mr-3 ml-0 mt-0 mb-3"
                        locale="ru"
                        readonly
                        :value="$moment(restriction.start_date).format('YYYY-MM-DD')"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </div>
                  <div class="inline-block">
                    <p class="title">Дата окончания</p>
                    <v-date-picker
                        class="mr-3 ml-0"
                        locale="ru"
                        readonly
                        :value="$moment(restriction.end_date).format('YYYY-MM-DD')"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </div>
                </v-flex>
              </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editRestriction(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить ограничение?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteRestrictionConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Ограничения', link: '/restrictions/active'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pageDataReady: {
          isReady: false,
          distributionChannelList: false
        },
        channelIdList: [],
        channelList: [],
        pointListTreeData: [],
        pointFolderIdList: [],
        pointIdList: [],
        productListTreeData: [],
        productCategoryIdList: [],
        productBrandIdList: [],
        productIdList: [],
        deleteDialog: false
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getRestrictionSingle', {id: this.$route.params.id})
    },
    computed: {
      restriction () {
        return this.$store.getters.restrictionSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productList () {
        return this.$store.getters.productList
      }
    },
    methods: {
      editRestriction (id) {
        this.$router.push('/restrictions/edit/' + id)
      },
      deleteRestrictionConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteRestriction', {id: this.id})
        this.$router.push('/restrictions/active/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      pointTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeData(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      },
      productTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].product_brand_list !== 'undefined') {
            for (let k = 0; k < tree[i].product_brand_list.length; k++) {
              treeData[i].children[k] = {
                text: tree[i].product_brand_list[k].title,
                state: {
                  expanded: true,
                  disabled: true
                },
                children: []
              }

              if (typeof tree[i].product_brand_list[k].product_sku_list !== 'undefined') {
                for (let j = 0; j < tree[i].product_brand_list[k].product_sku_list.length; j++) {
                  treeData[i].children[k].children[j] = {
                    text: tree[i].product_brand_list[k].product_sku_list[j].title,
                    children: [],
                    state: {
                      checked: true
                    }
                  }
                }
              }

              if (treeData[i].children[k].children.length === 0) {
                treeData[i].children[k].state.checked = true
              } else {
                treeData[i].children[k].children.push({text: '', state: {checked: true, visible: false}})
                treeData[i].children[k].children.push({text: '', state: {checked: false, visible: false}})
              }
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      }
    },
    watch: {
      restriction (n, o) {
        if (typeof this.restriction.distribution_channel_list !== 'undefined') {
          this.channelIdList = []
          for (let i = 0; i < this.restriction.distribution_channel_list.length; i++) {
            this.channelIdList.push(this.restriction.distribution_channel_list[i].id)
          }
        }

        if (typeof this.restriction.point_folder_list !== 'undefined') {
          this.pointFolderIdList = []
          for (let i = 0; i < this.restriction.point_folder_list.length; i++) {
            this.pointFolderIdList.push(this.restriction.point_folder_list[i].id)
          }
        }

        if (typeof this.restriction.point_list !== 'undefined') {
          this.pointIdList = []
          for (let i = 0; i < this.restriction.point_list.length; i++) {
            this.pointIdList.push(this.restriction.point_list[i].id)
          }
        }

        if (typeof this.restriction.product_category_list !== 'undefined') {
          this.productCategoryIdList = []
          for (let i = 0; i < this.restriction.product_category_list.length; i++) {
            this.productCategoryIdList.push(this.restriction.product_category_list[i].id)
          }
        }

        if (typeof this.restriction.product_category_brand_list !== 'undefined') {
          this.productBrandIdList = []
          for (let i = 0; i < this.restriction.product_category_brand_list.length; i++) {
            this.productBrandIdList.push(this.restriction.product_category_brand_list[i].id)
          }
        }

        if (typeof this.restriction.product_sku_list !== 'undefined') {
          this.productIdList = []
          for (let i = 0; i < this.restriction.product_sku_list.length; i++) {
            this.productIdList.push(this.restriction.product_sku_list[i].id)
          }
        }

        if (typeof this.restriction.point_folder_tree !== 'undefined') {
          this.pointListTreeData = this.pointTreeData(this.restriction.point_folder_tree)
        }

        if (typeof this.restriction.product_category_tree !== 'undefined') {
          this.productListTreeData = this.productTreeData(this.restriction.product_category_tree)
        }

        this.id = this.restriction.id
        if (this.restriction.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        this.actions.canUpdate = this.restriction.can_update
        this.actions.canRemove = this.restriction.can_remove

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Ограничения', link: '/restrictions/active'}
        ]
        this.breadcrumbs.push({name: this.restriction.title})

        this.$store.commit('setPageTitle', this.restriction.title)
        this.$store.dispatch('getDistributionChannelList')
          .then(() => {
            this.pageDataReady.distributionChannelList = true
            this.pageDataStatus()
          })
      },
      productList (n, o) {
        this.productListTreeData = this.productTreeData(this.productList)
      },
      distributionChannelList (n, o) {
        this.channelList = []
        for (let i = 0; i < this.distributionChannelList.length; i++) {
          this.channelList[i] = this.distributionChannelList[i]
        }

        if (this.channelIdList.length > 0) {
          for (let i = 0; i < this.channelList.length; i++) {
            let position = this.channelIdList.indexOf(this.channelList[i].id)
            if (~position) {
              this.channelList[i].checked = true
            } else {
              this.channelList[i].checked = false
            }
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Restrictions/RestrictionSingle.vue